import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';
import reportWebVitals from './reportWebVitals';
import './i18n/config';
import { MsalProvider } from '@azure/msal-react';
import { PublicClientApplication, Configuration, EventType } from '@azure/msal-browser';
import { AuthTokenProvider } from './contexts/AuthTokenContext';

const container = document.getElementById('root');
if (!container) throw new Error('Failed to find the root element');
const root = createRoot(container);

const msalConfig: Configuration = {
  auth: {
    clientId: process.env.REACT_APP_AAD_CLIENT_ID!,
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_AAD_TENANT_ID}`,
  },
};

const msalInstance = new PublicClientApplication(msalConfig);

// Ensure MSAL is initialized before rendering
msalInstance.initialize().then(() => {
  // Handle the response from auth redirects
  msalInstance.handleRedirectPromise().then(() => {
    root.render(
      <React.StrictMode>
        <MsalProvider instance={msalInstance}>
          <AuthTokenProvider>
            <App />
          </AuthTokenProvider>
        </MsalProvider>
      </React.StrictMode>
    );
  });
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
